import { createRoot } from "react-dom/client";
import { Profile } from "./Profile";
import { SAESearch } from "./SAESearch";

// // TODO: I would like to pass in the containerId as a prop to the App component.
// // Hard coded for now, though.
const singleContainerId = "ace-single-institution-root";
const singleContainer = document.getElementById(singleContainerId);

if (singleContainer) {
    const root = createRoot(singleContainer)
    root.render(<Profile />);
}

const searchContainerId = "ace-search-saec-root";
const searchContainer = document.getElementById(searchContainerId);

if (searchContainer) {
    const root = createRoot(searchContainer)
    root.render(<SAESearch />);
}
